<template>
    <div class="routers-card">
        <v-col>
            <v-row justify="center">
                <p class="header-title text size-xsmall weight-bold pb-0">N° Box SH-BOX {{ headerTitle }}</p>
            </v-row>
            <v-row justify="center">
                <div class="box-card theme-card ">
                    <div class="card-header">
                        <v-img 
                            class="card-header-img"
                            max-height="189"
                            max-width="403"
                            src="../../assets/images/restaurant.jpg">
                        </v-img>
                        <v-row justify="end">
                            <v-icon 
                                class="more-icon material-icons-outlined pa-4"
                            >
                                more_horiz
                            </v-icon>
                        </v-row>
                        <v-row 
                            justify="center" 
                            class="pt-7"
                        >
                            <strong class="text weight-bold size-medium">{{ title }}</strong> 
                        </v-row>
                        <v-row justify="center">
                            <p class="text-card-grey">{{ subtitle }}</p>
                        </v-row>
                        <v-row 
                            justify="center"
                            class="pt-4"
                        >
                            <customButton 
                                class="router-btn"
                                :label="status.online.label"
                                :status="status.online.label"
                                :icon="status.online.icon"
                                iconColor="white"
                                btnForm
                                hasBigHeight
                            />
                        </v-row>
                    </div>
                </div>
                <div class="router rounded-circle">
                    <v-icon
                        class="router-icon material-icons-outlined"
                    >
                        router
                    </v-icon>
                </div>
                
            </v-row>
        </v-col>
</div>
</template>

<script type="text/javascript">
import customButton from '@/components/buttons/customButton.vue'

    export default {
        name: 'color-marker',
        components: {
            customButton
        },
        props : {
            headerTitle: {
                type: String,
                default: '',
            },
            title: {
                type: String,
                default: '',
            },
            subtitle: {
                type: String,
                default: '',
            }
        },
        data () {
            return {
                status : {
                    online : {
                        label: "En ligne",
                        icon: "check",
                    },
                    progress : {
                        label: "En mise à jour",
                        icon: "settings"
                    },
                    offline : {
                        label: "Hors ligne",
                        icon: "highlight_off"
                    }
			    },
            }
        },
        computed : {
            // nbRouters () {
            // 	return this.$store.state.routers.routers.value.length;
            // },
        },
        created () {
            
        },
        methods : {}
    }

</script>

<style lang="scss">
    .routers-card {
        .header-title {
            color: $purple-alt;
            text-align: center;
            padding-top: 136px;
        }
        .box-card {
            height: 26.1em !important;
            width: 24.7em !important;
            border-radius: 20px !important;
            background-color: $pure-white;
            position: relative;
            z-index: 1;

        }
        .card-header {
            height: 9.8em !important;
        }
        .card-header-img {
            border-radius: 20px 20px 0px 0px !important;
        }
        .router {
            background-color: $purple-alt;
            width: 6.68em !important;
            height: 6.75em !important;
            margin-top: 8.3em;
            position: absolute;
            z-index: 2;
            .router-icon {
                font-size: 65px !important;
                padding-left: 19%;
                padding-top: 10%;
                color: $pure-white;
            }
        }
        .more-icon {
            color: $blue-icon;
        }
    }
</style>